import React from 'react';
import { Tabs } from 'antd';
import ParcelRateQuote from './ParcelRateQuote';
import PalletRateQuote from './PalletRateQuote';

const ShippingRatesPage: React.FC = () => {
  return (
    <div className="p-6">
      <Tabs
        defaultActiveKey="parcel"
        items={[
          { key: 'parcel', label: '快递包裹', children: <ParcelRateQuote /> },
          { key: 'pallet', label: '托盘运输', children: <PalletRateQuote /> },
        ]}
      />
    </div>
  );
};

export default ShippingRatesPage;
